import { Injectable, Inject, LOCALE_ID, ElementRef } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Customer } from '../../app/models/Customer';
import { User } from '../../app/models/User';
import { CurrentAccount } from '../../app/models/CurrentAccount';
import { Card } from '../../app/models/Card';
import { ConfigService } from '../config/config.service';
import { ConfigurableDatetimePipe } from '../../app/utilities/ConfigurableDatetimePipe';


@Injectable()
export class Utils {

  private readonly inputDateStringFormat = 'yyyy-MM-dd';
  private readonly shortDateStringFormat = 'short';

  constructor(@Inject(LOCALE_ID) private locale: string,
    private configService: ConfigService) { }

  private datePipe: DatePipe = new DatePipe(this.locale);
  private configurableDatetimePipe: ConfigurableDatetimePipe = new ConfigurableDatetimePipe(this.locale, this.configService);

  public toInputDateString(value): string {
    return this.datePipe.transform(new Date(value), this.inputDateStringFormat);
  }

  public toShortDateStringFormat(value): string {
    return this.datePipe.transform(new Date(value), this.shortDateStringFormat);
  }

  public toConfiguredDatetimeStringFormat(value): string {
    return this.configurableDatetimePipe.transform(new Date(value));
  }

  public reformatAllAccountsOwnerInputDateStrings(accountsOwner: Customer | User) {
    if (accountsOwner.dateOfBirth) {
      accountsOwner["_beforeReformat_dateOfBirth"] = accountsOwner.dateOfBirth;
      accountsOwner.dateOfBirth = this.toInputDateString(accountsOwner.dateOfBirth);
    }
  }

  public reformatAllCurrentAccountInputDateStrings(currentAccount: CurrentAccount) {
    if (currentAccount.checkIn) {
      currentAccount["_beforeReformat_checkIn"] = currentAccount.checkIn;
      currentAccount.checkIn = this.toInputDateString(currentAccount.checkIn);
    }
    if (currentAccount.checkOut) {
      currentAccount["_beforeReformat_checkOut"] = currentAccount.checkOut;
      currentAccount.checkOut = this.toInputDateString(currentAccount.checkOut);
    }
  }

  public reformatAllCardInputDateStrings(card: Card) {
    if (card.activationDate) {
      card["_beforeReformat_activationDate"] = card.activationDate;
      card.activationDate = this.toInputDateString(card.activationDate);
    }
    if (card.expirationDate) {
      card["_beforeReformat_expirationDate"] = card.expirationDate;
      card.expirationDate = this.toInputDateString(card.expirationDate);
    }
  }

  public sortCurrentAccountsByNoCheckoutFirstAndCheckInDateDescending(currentAccounts: CurrentAccount[]): CurrentAccount[] {
    return currentAccounts.sort((a: CurrentAccount, b: CurrentAccount) => {
      let result: number = 0;
      if ((a.checkOut && b.checkOut) || (!a.checkOut && !b.checkOut)) {
        result = new Date(b.checkIn).valueOf() - new Date(a.checkIn).valueOf();
        if (result == 0 && (a.checkOut && b.checkOut)) {
          result = new Date(b.checkOut).valueOf() - new Date(a.checkOut).valueOf();
        }
      }
      if (result == 0) {
        result = a.checkOut ? 1 : -1;
      }
      return result;
    });
  }

  public isCheckInBeforeNow(currentAccount: CurrentAccount): boolean {
    return Date.now() - new Date(currentAccount.checkIn).valueOf() >= 0;
  }

  public countDaysBetween(startDate: string, endDate: string): number {
    var day = 24 * 60 * 60 * 1000;
    var from = new Date(startDate);
    var to = new Date(endDate);
    return Math.round(Math.abs((from.getTime() - to.getTime()) / (day)));
  }

  public focus(el: ElementRef) {
    el.nativeElement.focus();
    el.nativeElement.select();
  }

  public toCents(x: number): number {
    let xParts: string[] = ('' + x).split('.');
    let int: string = xParts[0] || "";
    let frac: string = xParts[1] || "00";
    if (frac.length > 2) {
      frac = frac.slice(2);
    }
    frac += "0".repeat(2 - frac.length);
    return Number.parseInt(int + frac);
  }

  public isSecondCircuit(card: Card): boolean {
    return card.type.name == 'Iron' && card.type.credit;
  }

}




// WEBPACK FOOTER //
// ./src/providers/paytron-backend/utils.ts